import { Link, useNavigate } from 'react-router-dom'
import { useNewsArticles, useLocale, urlFor, getPortableTextExcerpt } from '@autoplan/web-sanity'
import { Breadcrumb, Heading, Stack } from '@autoplan/web-ui'
import { NewsCard } from '../components/Cards/NewsCard'

export const Articles = () => {
  const articles = useNewsArticles()
  const navigate = useNavigate()
  const { t } = useLocale()

  return (
    <Stack spacing="xl">
      <Breadcrumb
        items={[
          { path: '/', label: t('home.breadcrumb.home') },
          { path: '/articles', label: t('home.breadcrumb.news') },
        ]}
        linkAs={Link}
      />
      <Heading size="lg">{t('home.news.title')}</Heading>
      <div className="ap:grid ap:grid-cols-1 ap:gap-xl ap:xl:grid-cols-2">
        {articles.map((article) => (
          <NewsCard
            key={article._id}
            title={article.title ?? ''}
            introduction={getPortableTextExcerpt(article.body)}
            imageSrc={article.image ? (urlFor(article.image)?.width(300).height(150).url() ?? undefined) : undefined}
            onClick={() => article.slug && navigate(`/articles/${article.slug.current}`)}
          />
        ))}
      </div>
    </Stack>
  )
}
